import React, { memo, useState } from 'react';
import Link from 'components/Link';
import PropTypes from 'prop-types';
import ImageV2 from 'components_v2/common/ImageV2';
import LeadLiveIcon from 'components_v2/common/LeadLiveIcon/LeadLiveIcon';
import Video from 'components/Video/Video';
import PopupOverlay from 'components_v2/common/PopupOverlay/PopupOverlay';
import s from './NewStoryCard.scss';
import { IMAGE_URL } from '../../../constants';
import ErrorBoundary from '../../../components/ErrorBoundary/ErrorBoundary';
import SocialSharingMobile from '../../../routes/articleshow_v2/components/mobile/SocialSharingMobile/SocialSharingMobile';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

function NewStoryCard({
  title,
  msid,
  isLarge,
  wu,
  imagesize,
  // isWapView,
  sectionName,
  shouldNotlazyloadImage,
  ga4Category,
  ga4Type,
  ga4Label,
  gaIndex,
  cardType,
  isBigHeading,
  isVideoActive,
  syn,
  iconClass,
  criticRating,
  cmstype,
  fromToiPrint,
  createdTime2,
  synStyle,
  target,
  createdTime,
  videoTime,
  slikeId,
  hoveredSlikeId,
  setSlikePreviewId,
  hoveredSlikeIndex,
  usePosterImage,
  tn,
  showIIcon,
  des,
  showPlayIconAlso,
  showPopup,
}) {
  if (!cmstype && tn) {
    const TN_CMSTYPE_MAPPING = {
      photostory: 'PHOTOGALLERYSLIDESHOWSECTION',
      video: 'MEDIAVIDEO',
      liveblog: 'LIVEBLOG',
    };
    const TN_ICONCLASS_MAPPING = {
      photostory: 'photoIcon',
      video: 'videoshowIcon',
      // liveblog: 'liveIconWrapper',
    };
    cmstype = TN_CMSTYPE_MAPPING[tn] || '';
    if (!iconClass) {
      iconClass = TN_ICONCLASS_MAPPING[tn] || '';
    }
  }
  const handleTouchStart = id => {
    //setSlikePreviewId(id, gaIndex);
    if (typeof setSlikePreviewId === 'function') {
      setSlikePreviewId(id, gaIndex);
    } else {
      console.log('setSlikePreviewId is not a function');
    }
  };
  const [showDes, setShowDes] = useState(false);
  const [showBannerPopup, setShowBannerPopup] = useState(false);
  const [bannerPopup, setBannerPopup] = useState(null);

  const ImageElement = ImageV2;
  const checkHtml = /(<([^>]+)>)/i;
  const htmlStatus = title ? checkHtml.test(title) : '';
  let resizemode;
  let iconClass2;
  let height;
  if (
    cardType !== 'card_10' &&
    (cmstype === 'PHOTOGALLERYSLIDESHOWSECTION' ||
      cmstype === 'MOVIEREVIEW' ||
      tn === 'movie reviews' ||
      tn === 'movie-review' ||
      usePosterImage)
  ) {
    resizemode = 75;
    height = 250;
  } else if (cardType === 'card_10') {
    iconClass2 = s.vsIcon;
  }

  const handleShowDesInCard = () => {
    setShowDes(!showDes);
  };

  const handleClosePopup = () => {
    if (document?.querySelector) {
      document.querySelector('body').classList.remove('overflowhidden');
    }
    setShowBannerPopup(false);
  };

  const handleBannerClick = banner => {
    if (document?.querySelector) {
      document.querySelector('body').classList.add('overflowhidden');
    }
    setShowBannerPopup(true);
    setBannerPopup(banner);
  };
  const updateplayerConfig = { skipReco: true };

  const renderPopupImage = () => (
    <PopupOverlay
      position="center"
      closeCallback={handleClosePopup}
      show={showBannerPopup}
      blackOverlayEnabled
      fixWidth
    >
      {bannerPopup.slikeId ? (
        <Video
          msid={bannerPopup.id}
          autoplay
          slikeId={bannerPopup.slikeId}
          playerType={bannerPopup.playerType}
          videoClassName="popup_video_wrapper"
          slikeNextVideoAutoPlayed={false}
          // slikeNextVideoAutoPlayed={this.state.slikeNextVideoAutoPlayed}
          //store={this.context.store}
          allowDim={false}
          source="USNHP_MainVideoWidget"
          updateplayerConfig={updateplayerConfig}
          // isUserPrime={this.props.isUserPrime}
          // outsideEventListener={(...args) => {
          //   this.videoEventListener(...args);
          // }}
        />
      ) : (
        <ImageElement
          //msid={bannerPopup.id}
          resizemode={4}
          imgsize={bannerPopup.imagesize}
          src={`${IMAGE_URL}${bannerPopup.id}.cms`}
          //width="620"
          alt={bannerPopup.hl}
          title={bannerPopup.title || ''}
          placeHolderSrc={`${IMAGE_URL}87458172.cms`}
        />
      )}
    </PopupOverlay>
  );

  const renderContent = () => (
    <>
      {cardType !== 'card_11' &&
        cardType !== 'card_12' && (
          <div className={s.imgWrap}>
            <div className={s.storyImg}>
              <ImageElement
                key={`${msid}_${gaIndex}`}
                width="375"
                msid={msid}
                placeHolderSrc={`${IMAGE_URL}87458172.cms`}
                alt=""
                lazyload={!shouldNotlazyloadImage}
                // offsetVertical={200}
                resizemode={resizemode}
                height={height}
                slikeId={slikeId}
                hoveredSlikeId={hoveredSlikeId}
                hoveredSlikeIndex={hoveredSlikeIndex}
                gaIndex={gaIndex}
                imgsize={imagesize}
              />
            </div>
            <span className={`${s[iconClass]} ${iconClass2}`}>
              <i />
              {videoTime && <span> {videoTime} </span>}
            </span>
            {showPlayIconAlso && (
              <span className={`${s.videoIcon}`}>
                <i />
              </span>
            )}
            {cmstype &&
              cmstype === 'LIVEBLOG' && (
                <span className={s.liveIconWrapper}>
                  <LeadLiveIcon />
                </span>
              )}
            {criticRating && (
              <div
                className={`${s.ratingWrap} ${
                  cardType === 'card_2' || cardType === 'card_3' ? s.topPos : ''
                }`}
              >
                <div className={s.ratingPosition}>
                  <div className={s.ratings}>
                    <p className={s.ratingsGiven}>
                      {criticRating} <span className={s.starIcon} />
                    </p>
                    <p className={s.ratingsBy}>Critics</p>
                  </div>
                  {/* <div className={s.line} />
                  <div className={s.ratings}>
                    <p className={s.ratingsGiven}>
                      {criticRating} <span className={s.starIcon} />
                    </p>
                    <p className={s.ratingsBy}>Audience</p>
                  </div> */}
                </div>
              </div>
            )}

            {showIIcon && (
              <span
                className={`${s[iconClass]} ${s.infoIcon}`}
                onClick={handleShowDesInCard}
              >
                i
              </span>
            )}

            {des && (
              <p
                className={`${s.infoTextOverlay} ${showDes ? s.show : ''}`}
                dangerouslySetInnerHTML={{ __html: des }}
              />
            )}
          </div>
        )}
      <div className={`${s.scContentWrap} bg_color`}>
        {htmlStatus ? (
          <p
            className={`${s.cardHeading} style_change`}
            dangerouslySetInnerHTML={{
              __html: title,
            }}
          />
        ) : (
          <p className={`${s.cardHeading} style_change`}>{title}</p>
        )}
        {createdTime2 && <p className={s.createdTime}>{createdTime2}</p>}
        {syn && (
          <p className={s.cardText} style={synStyle}>
            {syn}
          </p>
        )}
        {sectionName && <div className={s.catText}>{sectionName}</div>}
        {fromToiPrint && (
          <div className={s.fromToiWrap}>
            <span>From TOI Print Edition</span>
            <ErrorBoundary>
              <SocialSharingMobile
                title={title}
                textRequired={false}
                url={wu || ''}
                disableShortUrl
                linkeDin
                via="@timesofindia"
                topsticky
                defaultEmailView
                isTablet={false}
                hideSharingButtons
                hideSharingNative
                placeHolderStyles={{ minHeight: '24px' }}
                placeHolderLoaderClass="follow_us_loader"
                hideFollow
              />
            </ErrorBoundary>
          </div>
        )}
        {createdTime && <span className={s.createdTime}> {createdTime}</span>}
      </div>
    </>
  );

  return wu ? (
    <Link
      // eslint-disable-next-line no-script-url
      to={wu || 'javascript:void(0)'}
      target={!target ? '_blank' : target}
      className={`border_color ${s.storyCard} ${isLarge ? s.isLarge : ''} ${
        cardType ? s[cardType] : ''
      } ${isBigHeading ? s.bigHeading : ''} ${!wu ? s.noLink : ''} ${
        isVideoActive ? s.videoActive : ''
      }`}
      onTouchStart={() => handleTouchStart(slikeId)}
      // onTouchEnd={() => sethoveredSlikeId(false)}
      onClick={e => {
        if (ga4Type) {
          analyticsWrapper('ga4', {
            event: 'user_click',
            type: `${ga4Type}`,
            category: ga4Category || 'story_click',
            story_no: `${gaIndex}`,
            msid,
            label: ga4Label,
          });
        }
        try {
          if (showIIcon || e.target.innerHTML === 'Share') {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        } catch (error) {
          //
        }
        return true;
      }}
    >
      {renderContent()}
    </Link>
  ) : (
    <>
      {bannerPopup &&
        showBannerPopup &&
        bannerPopup?.imageid &&
        renderPopupImage()}
      <div
        className={`border_color normalStoryCard ${s.storyCard} ${
          isLarge ? s.isLarge : ''
        } ${cardType ? s[cardType] : ''} ${isBigHeading ? s.bigHeading : ''} ${
          isVideoActive ? s.videoActive : ''
        }`}
        onTouchStart={() => handleTouchStart(slikeId)}
        // onTouchEnd={() => sethoveredSlikeId(false)}
        onClick={e => {
          if (ga4Type) {
            analyticsWrapper('ga4', {
              event: 'user_click',
              type: `${ga4Type}`,
              category: ga4Category || 'story_click',
              story_no: `${gaIndex}`,
              msid,
              label: ga4Label,
            });
          }
          if (showPopup) {
            e.preventDefault();
            const data = {
              imageid: msid,
              slikeId,
              id: msid,
              resizemode,
            };
            handleBannerClick(data);
          }

          try {
            if (showIIcon || e.target.innerHTML === 'Share') {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          } catch (error) {
            //
          }
          return true;
        }}
      >
        {renderContent()}
      </div>
    </>
  );
}
NewStoryCard.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  isLable: PropTypes.bool,
  isLarge: PropTypes.string,
  ga4Type: PropTypes.string,
  ga4Label: PropTypes.string,
  gaIndex: PropTypes.number,
  cardType: PropTypes.string,
  shouldNotlazyloadImage: PropTypes.bool,
  showPopup: PropTypes.bool,
};

NewStoryCard.defaultProps = {
  isLable: false,
  isLarge: '',
  ga4Type: '',
  ga4Label: '',
  gaIndex: '',
  cardType: '',
  shouldNotlazyloadImage: false,
  showPopup: false,
};

export default memo(NewStoryCard);
